module.exports = __webpack_public_path__ + "img/what-we-sell_0000.9158b3f6.jpg";